module.exports = __webpack_public_path__ + "static/home/img/3.db3bc471.png";